export default "__VITE_ASSET__Cuz5TInR__"